var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.order.orderData, function (item) {
        return _c("div", { staticClass: "itemRow text-left" }, [
          item.isCoupon
            ? _c("table", { staticClass: "maxw items" }, [
                _c("tr", [
                  _c("td", { staticClass: "counter" }, [_vm._v("1x")]),
                  _c("td", { staticClass: "b text-left" }, [
                    _c("div", {}, [
                      _c("div", { staticClass: "biggerFont" }, [
                        _vm._v(_vm._s(item.nameToDisplay) + " "),
                        item.description
                          ? _c("span", [
                              _vm._v(" | " + _vm._s(item.description)),
                            ])
                          : _vm._e(),
                      ]),
                      item.text.length > 0
                        ? _c("div", { staticClass: "displayExtras" }, [
                            _vm._v(" " + _vm._s(item.text) + " "),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  !_vm.$store.getters.hidePrices
                    ? _c("td", { staticClass: "e text-right" }, [
                        item.type === "bundle"
                          ? _c("div", [
                              _vm._v(_vm._s(_vm._f("price")(item.amount))),
                            ])
                          : _vm._e(),
                        item.type === "amount"
                          ? _c("div", [
                              _vm._v(
                                "-" + _vm._s(_vm._f("price")(item.amount))
                              ),
                            ])
                          : _vm._e(),
                        item.type === "discount"
                          ? _c("div", [
                              _vm._v("-" + _vm._s(item.discount) + "%"),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _c("table", { staticClass: "maxw items" }, [
                _c("tr", [
                  _c("td", { staticClass: "counter biggerFont" }, [
                    _vm._v(_vm._s(item.count) + "x"),
                  ]),
                  _c("td", { staticClass: "b text-left" }, [
                    _c("div", {}, [
                      _c("div", [
                        item.gang
                          ? _c("div", { staticClass: "gang" }, [
                              _vm._v(
                                _vm._s(_vm._f("uppercase")(item.gang)) + ":"
                              ),
                            ])
                          : _vm._e(),
                        _c("span", [
                          _vm._v(
                            _vm._s(item.nameToDisplay) +
                              " " +
                              _vm._s(_vm.displayItemVol(item)) +
                              " "
                          ),
                        ]),
                      ]),
                      item.extras.length > 0
                        ? _c("div", { staticClass: "displayExtras" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("extrasList")(item.extras, true)
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      item.notes
                        ? _c("div", { staticClass: "font-italic" }, [
                            _vm._v(_vm._s(item.notes)),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  !_vm.$store.getters.hidePrices
                    ? _c("td", { staticClass: "e text-right" }, [
                        _vm._v(_vm._s(_vm._f("price")(item.itemTotal))),
                      ])
                    : _vm._e(),
                ]),
              ]),
        ])
      }),
      _vm.order?.paymentInfo?.tipAmount
        ? _c(
            "div",
            {
              staticClass: "text-right flex-grow-1 itemRow",
              staticStyle: { border: "none" },
            },
            [
              _c("div", { staticClass: "d-inline-block" }, [
                _c("table", { staticClass: "mySumTable" }, [
                  _c("tr", [
                    _c("td", [_vm._v("Trinkgeld:")]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm._f("price")(_vm.order.paymentInfo.tipAmount))
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.order.appliedDiscounts
        ? _c(
            "div",
            [
              _c("DiscountsSummary", {
                attrs: { "applied-discounts": _vm.order.appliedDiscounts },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "itemRow text-right", staticStyle: { border: "none" } },
        [
          _vm.totalSavedByDiscounts > 0
            ? _c("h3", { staticClass: "rabattColor" }, [
                _vm._v(
                  "Rabatt: " +
                    _vm._s(_vm._f("priceTotal")(_vm.totalSavedByDiscounts))
                ),
              ])
            : _vm._e(),
          _c("h3", [
            _vm._v(
              "Gesamt: " +
                _vm._s(_vm._f("priceTotal")(_vm.order.paymentInfo.amount))
            ),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }